import FrameRedirectHandler from './FrameRedirectHandler.jsx';
export default FrameRedirectHandler;